import React from 'react'

class TodoItemType extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      id      : this.props.id,
      schema  : this.props.schema,
    }
  }

  render() {
    // console.log(`input-text schema (${this.state.id}): ${JSON.stringify(this.state.schema)}`)
    return (
      <div>
      {
        this.state.schema && this.state.schema.type
        ? `${this.state.id} (ItemType: ${this.state.schema.type} to be implemented)`
        : `${this.state.id} (ItemType: to be implemented)`
      }
      </div>
    )
  }
}

module.exports = TodoItemType



// WEBPACK FOOTER //
// ./item-types/todo-item-type.js